module.exports = __webpack_public_path__ + "static/media/rw-widgets.12f0820c.woff";